// Hasil scan/cari Rido untuk pesanan yang tidak tampil di tab aktif (revisi, HOLD, beda tab).
// Barcode = nomor pesanan Shopee (stabil antar revisi). Scan TIDAK pernah dianggap bukti cetak/ACC.
import React from "react";

export const MSG_REVISED = "MOCKUP SUDAH DIREVISI — Periksa dan cetak desain terbaru sebelum ACC.";

export const MSG_STALE = "Mockup sedang direvisi. Tunggu desainer menandai FIX dan mengirim ulang ke Gudang. Jangan cetak atau ACC menggunakan versi lama.";
export const STALE_FILE_LABEL = "Versi lama — tidak berlaku untuk produksi";
// Kiriman Gudang terakhir tidak berlaku selama mockup belum FIX lagi (hanya penanda tampilan, status tidak diubah).
export const isStaleSnapshot = (j) => !!j && j.status !== "FIX" && j.warehouse_state !== "cancelled";

export function StaleWarning({ testid }) {
  return <div className="warn-box small" role="alert" style={{ margin: "6px 0", fontWeight: 700, color: "#b3261e", borderColor: "#f3b4b4", background: "#fdecec" }}
    data-testid={testid}>{MSG_STALE}</div>;
}

export function scanStateOf(j) {
  if (j.cancellation_status === "canceled_internal" || j.shopee_cancelled)
    return { tone: "bad", text: `Pesanan dibatalkan (final)${j.mockup_printed_at ? " — sudah dicetak, jangan diproses" : " — jangan dicetak"}.`, reprint: false };
  if (j.warehouse_state === "cancelled") return { tone: "bad", text: "Pesanan dibatalkan — tidak diproses.", reprint: false };
  if (j.warehouse_state === "on_hold") return { tone: "warn", text: "DITAHAN (HOLD) — menunggu revisi desainer. Jangan ACC; cetak ulang setelah revisi dikirim.", reprint: false };
  if (j.status !== "FIX") return { tone: "warn", text: MSG_STALE, reprint: false, stale: true };
  if (j.revised_after_print) return { tone: "warn", text: `${MSG_REVISED} Versi terbaru belum masuk kartu Gudang — minta desainer Kirim Ulang ke Gudang.`, reprint: false };
  if (j.revised_since_print) return { tone: "warn", text: `${MSG_REVISED} Kertas lama tidak berlaku.`, reprint: true };
  return { tone: "ok", text: j.mockup_printed_at ? "Ada di tab Sudah Dicetak." : "Ada di tab Belum Dicetak.", reprint: true };
}

export function ScanFoundBanner({ jobs, onOpen, onReprint }) {
  if (!jobs.length) return null;
  return <div className="warn-box small" style={{ margin: "8px 0" }} data-testid="wh-shopee-scan-found">
    {jobs.map(j => { const s = scanStateOf(j);
      return <div key={j.id} style={{ marginBottom: 6 }} data-testid={`wh-shopee-scan-found-${j.id}`}>
        <b>{j.order_number}</b> — <span style={{ fontWeight: s.tone === "warn" ? 700 : 400, color: s.tone === "ok" ? undefined : "#b3261e" }}
          data-testid={`wh-shopee-scan-state-${j.id}`}>{s.text}</span>
        <div style={{ display: "flex", gap: 6, marginTop: 4 }}>
          <button type="button" className="soft-btn small-btn" onClick={() => onOpen(j)} data-testid={`wh-shopee-scan-open-${j.id}`}>{s.stale ? "Lihat Versi Lama (terakhir dikirim)" : "Lihat Mockup Terbaru"}</button>
          {s.reprint && <button type="button" className="soft-btn small-btn" onClick={() => onReprint(j)} data-testid={`wh-shopee-scan-reprint-${j.id}`}>Cetak Ulang Mockup</button>}
        </div>
      </div>; })}
  </div>;
}
